import { z } from 'zod';
/** Current option execution evidence in a named experiment or training window. */
export const experimentOptionComparisonEvidenceSchema = z.object({
    policyRevision: z.number().int().positive(),
    resultKind: z.literal('executed_option_trade'),
    evidenceWindow: z.enum(['experiment', 'training']),
    evidenceCutoffTimestamp: z.number().int().nullable(),
    recordedAttemptCount: z.number().int().nonnegative(),
    completedCount: z.number().int().nonnegative(),
    notEnteredCount: z.number().int().nonnegative(),
    pendingSettlementCount: z.number().int().nonnegative(),
    openCensoredCount: z.number().int().nonnegative(),
    missingDataCount: z.number().int().nonnegative(),
    unsupportedCapabilityCount: z.number().int().nonnegative(),
    evaluationFailureCount: z.number().int().nonnegative(),
    ineligibleCompletedCount: z.number().int().nonnegative(),
    firstCompletionTimestamp: z.number().int().nullable(),
    lastCompletionTimestamp: z.number().int().nullable(),
    // Historical persisted reports predate detailed rejection reporting.
    rejectionReasons: z
        .array(z.object({
        code: z.string(),
        detail: z.string().nullable(),
        count: z.number().int().positive()
    }))
        .max(20)
        .optional(),
    benchmarkStatus: z.enum([
        'available_contextual',
        // Retained so reports produced by the short-lived matched-policy
        // classification remain readable. Current producers do not emit it.
        'available_matched_policy',
        'partial_coverage',
        'unavailable_incompatible_policy',
        'unavailable_missing_baseline',
        // Retained so historical persisted reports remain readable.
        'unavailable_unmatched_execution_window'
    ])
});
//# sourceMappingURL=ExperimentOptionComparison.js.map